import { css } from '@emotion/react';
import { media } from '../../../../styles/breakpoints-2026';

export const sortBy = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
`;

export const select = css`
  display: flex;
  justify-content: flex-end;
`;

export const mobileOnly = css`
  ${media('>=tablet')} {
    display: none;
  }
`;

export const tabletAndUp = css`
  display: none;

  ${media('>=tablet')} {
    display: inline;
  }
`;
